import React, { useState, useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { allMetricsAtom, selectedMetricsAtom, updateAnchorAtom, metricOrderAtom } from '../atoms';
import { MAX_ANCHORED_COUNT } from '../utils';
import CustomizeDropdown from '@components/common/CustomizeDropdown';
import { getSecondaryMetric, isSecondaryOnlyMetric } from '@src/utils/metrics/metricHelpers';

const MetricDropMenu = ({
  selectedMetrics = [],
  anchoredMetrics = {},
  exceedTimeLimit = false,
  mandatoryDimensions,
}) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const metricOrder: any = useAtomValue(metricOrderAtom);
  const [innerSelectedMetrics, setInnerSelectedMetrics] = useState([]);
  const allMetrics = useAtomValue(allMetricsAtom);
  const setAnchorMetrics = useSetAtom(updateAnchorAtom);
  const setSelectedMetrics = useSetAtom(selectedMetricsAtom);

  useEffect(() => {
    setInnerSelectedMetrics(selectedMetrics);
  }, [selectedMetrics, anchoredMetrics]);

  const applySelectedMetrics = (metrics) => {
    // when one metric unselected, if its secondary metric is secondary only
    // also unselect its secondary metric if existed
    let res = metrics;
    selectedMetrics.forEach((metric) => {
      if (!metrics.includes(metric)) {
        const secondaryMetric = getSecondaryMetric({ metricKey: metric });
        if (secondaryMetric && isSecondaryOnlyMetric({ metricKey: secondaryMetric })) {
          res = metrics.filter((item) => item !== secondaryMetric);
        }
      }
    });

    const orderedMetrics = res.sort((a: string, b: string) => {
      return metricOrder.indexOf(a) - metricOrder.indexOf(b);
    });
    setSelectedMetrics(orderedMetrics);
  };

  const applyAnchorMetrics = (metric) => {
    setAnchorMetrics(metric);
  };

  return (
    <div id="viewer-session-customize-dropdown" ref={containerRef}>
      <CustomizeDropdown
        maxAnchorCount={MAX_ANCHORED_COUNT}
        allMetrics={allMetrics}
        selectedMetrics={innerSelectedMetrics}
        anchoredMetrics={anchoredMetrics}
        disabled={exceedTimeLimit}
        mandatoryDimensions={mandatoryDimensions}
        getPopupContainer={() => containerRef.current || document.body}
        onAnchorMetricsChange={applyAnchorMetrics}
        onSelectedMetricsChange={applySelectedMetrics}
      />
    </div>
  );
};

export default MetricDropMenu;
